<template>
  <div id="app">
    <v-container>
      <Header />
      <EventSlot v-if="viewSlot" />
      <EventWorkshop v-if="viewWorkshop" />
      <EventRegisterInterest v-if="viewRegister" />
      <EventHealthScreening v-if="viewHealthscreening || viewVirustesting" />
    </v-container>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import EventSlot from "../components/EventSlot";
import EventWorkshop from "../components/EventWorkshop";
import EventRegisterInterest from "../components/EventRegisterInterest";
import EventHealthScreening from "../components/EventHealthScreening";

export default {
  components: {
    EventSlot,
    EventWorkshop,
    EventRegisterInterest,
    EventHealthScreening,
    Header
  },
  data() {
    return {
      viewSlot: false,
      viewWorkshop: false,
      viewRegister: false,
      viewHealthscreening: false,
      viewVirustesting: false
    };
  },
  created() {
    switch (this.$route.params.eventType) {
      case "slot":
        this.viewSlot = true;
        break;
      case "workshop":
        this.viewWorkshop = true;
        break;
      case "register":
        this.viewRegister = true;
        break;
      case "healthscreening":
        this.viewHealthscreening = true;
        break;
      case "virustesting":
        this.viewVirustesting = true;
        break;
    }
  }
};
</script>
